import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ResetDeviceService } from '../../Model/ResetDevice/reset-device.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-imeisearch',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './imeisearch.component.html',
  styleUrl: './imeisearch.component.scss'
})
export class IMEISearchComponent {
  public User: any = null;
  IMEINo: string = '';
  IMEINoLoad: any[] = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {};
  constructor(private modalService: NgbModal,
    private resetDevice: ResetDeviceService,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {}
  
  Search() {
    this.isDisabled = true;
    this.resetDevice.ESS_EmpDetailsOnIMEI({ 'IMEINumber': this.IMEINo }).subscribe(
      data => {
        if (data && data.Table) {
          this.IMEINoLoad = data.Table;
          if (this.IMEINoLoad.length === 0) {
            this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
            this.IMEINoLoad = [];
          }
        } else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
          this.IMEINoLoad = [];
        }
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }

  onKeyPress() {
    this.IMEINoLoad = [];
  }
}
